import { gql } from '@apollo/client';

import { MediaApprovalMaStatus } from '../query/moderate.queries';

/*
** APPROVE OR REJECT MEDIA APPROVAL **
*/

export const APPROVE_OR_REJECT_MEDIA_APPROVAL = gql`
  mutation approveOrRejectMediaApproval($input: MediaApprovalPatch!) {
    approveOrRejectMediaApproval(input: $input) {
      mediaId
      message
    }
  }
`;

export type MediaApprovalPatch = {
  maId: string;
  maStatus: MediaApprovalMaStatus;
  maRejectionReason?: string;
};

export type ApproveOrRejectMediaApprovalData = {
  approveOrRejectMediaApproval: {
    mediaId: string;
    message: string;
  };
};

export type ApproveOrRejectMediaApprovalVariables = {
  input: MediaApprovalPatch;
};
